import { authFetch } from './client';

// Invitee-side: keyed on the caller's verified email and/or an emailed token.
export const pendingInvites = () => authFetch('/api/orgs/pending-invites');
export const acceptInvite = (orgId, inviteId, token) =>
  authFetch('/api/orgs/accept-invite', {
    method: 'POST',
    body: JSON.stringify({ orgId, inviteId, token }),
  });
export const declineInvite = (orgId, inviteId) =>
  authFetch('/api/orgs/decline-invite', {
    method: 'POST',
    body: JSON.stringify({ orgId, inviteId }),
  });
